// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fees-for-security-form .el-form--inline[data-v-5d6c671e] {\n  display: flex;\n  justify-content: space-between;\n}\n.fees-for-security-form .el-form-item[data-v-5d6c671e] {\n  width: 60em;\n}\n.fees-for-security-form .parent_Box[data-v-5d6c671e] {\n  padding-right: 15px;\n}", ""]);
// Exports
module.exports = exports;
